import { useQuery } from '@tanstack/react-query';
import type { AdsCreativePrompt } from '@brand24-original/llm-types';
import { AdsFilters, getAdsCreativePrompts } from '../../services/ads/AdsService';
import { GET_ADS_CREATIVE_PROMPTS } from '../../query/ads/keys';

/** Prompts where one creative appeared — fetched lazily when a By-ad row is expanded. */
export const useGetAdsCreativePrompts = (
  projectId: number | null,
  from: Date | null,
  to: Date | null,
  adKey: string,
  filters: AdsFilters
) => {
  const queryEnabled = !!projectId && !!from && !!to && !!adKey;

  const { data, isLoading, isError, refetch } = useQuery<AdsCreativePrompt[]>({
    queryKey: [
      GET_ADS_CREATIVE_PROMPTS,
      projectId,
      from,
      to,
      adKey,
      filters.models,
      filters.promptIds,
      filters.advertisers,
    ],
    queryFn: () => getAdsCreativePrompts(projectId!, from!, to!, adKey, filters),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
  });

  return {
    creativePrompts: queryEnabled ? data ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
